import React, { useCallback, useEffect, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

interface Item {
  [key: string]: any;
}

interface InputDropSearchProps {
  data: Item[];
  label: string;
  value?: any;
  selectName1: string;
  selectName2?: string;
  value2Name?: string;
  noMgs?: string;
  extraMsg?: string;
  selectValue: string;
  onChange: (event: {
    target: { name: string; value: any; valueTitle: string; value2: any };
  }) => void;
  onSearch: (value: string) => void;
  name: string;
  isDisable?: boolean;
  errors?: boolean;
  errormessage?: string;
}

const InputDropSearch: React.FC<InputDropSearchProps> = ({
  value,
  data,
  label,
  selectName1,
  selectName2,
  value2Name,
  selectValue,
  onChange,
  onSearch,
  name,
  isDisable = false,
  errors,
  errormessage,
  noMgs,
  extraMsg,
}) => {
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [select, setSelect] = useState<{ name: string; id: any }>({
    name: "",
    id: "",
  });

  const handleOpen = useCallback(() => {
    if (!isDisable) setOpen((prevOpen) => !prevOpen);
  }, [isDisable]);

  const handleSearch = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const searchTerm = e.target.value;
      setSearch(searchTerm);
      onSearch(searchTerm);
    },
    [onSearch]
  );

  const handleSelect = useCallback(
    (item: Item) => {
      const selectedItem = {
        name: item.name,
        id: item.id,
      };
      
      
      setSelect(selectedItem);
      onChange({
        target: {
          name,
          value: item.id,
          valueTitle: item.name,
          value2: item?.item,
        },
      });
      setOpen(false);
    },
    [name, onChange]
  );

  useEffect(() => {
    if (value) {
      const selectedItem = data.find((item) => item[selectValue] === value);
      setSelect({
        name: selectedItem?.[selectName1] || "",
        id: value,
      });
    } else {
      setSelect({ name: "", id: "" });
    }
  }, [value, data, selectName1, selectValue]);

  return (
    <div className="w-full flex flex-col gap-1.5 relative">
      <label className="block text-xs font-medium text-slate-700 dark:text-slate-300">
        {label}
      </label>
      <div
        className={`w-full h-10 px-3 rounded-lg border flex items-center justify-between cursor-pointer transition-colors text-sm
          bg-slate-50 dark:bg-slate-700 border-slate-200 dark:border-slate-600
          hover:border-slate-300 dark:hover:border-slate-500
          text-slate-800 dark:text-slate-200
          ${errors ? "border-red-500 dark:border-red-400" : ""}
          ${isDisable ? "opacity-60 cursor-not-allowed" : ""}`}
        onClick={handleOpen}
      >
        <span className={select.name !== "" ? "" : "text-slate-400 dark:text-slate-500"}>
          {select.name !== "" ? select.name : "Select"}
        </span>
        {open ? (
          <KeyboardArrowUpIcon className="text-slate-500 dark:text-slate-400" sx={{ fontSize: 18 }} />
        ) : (
          <KeyboardArrowDownIcon className="text-slate-500 dark:text-slate-400" sx={{ fontSize: 18 }} />
        )}
      </div>
      {open && (
        <ul className="absolute top-full left-0 right-0 mt-1 z-50 max-h-64 overflow-y-auto rounded-lg border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-800 shadow-lg">
          <li className="p-2 border-b border-slate-100 dark:border-slate-600 sticky top-0 bg-white dark:bg-slate-800">
            <input
              type="text"
              onChange={handleSearch}
              value={search}
              placeholder="Search here"
              className="w-full h-8 px-3 rounded-md border border-slate-200 dark:border-slate-600 bg-slate-50 dark:bg-slate-700 text-slate-800 dark:text-slate-200 text-sm placeholder:text-slate-400 dark:placeholder:text-slate-500 focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none"
              onClick={(e) => e.stopPropagation()}
            />
          </li>
          {data.map((item, i) => (
            <li
              key={i}
              onClick={() =>
                handleSelect({
                  id: item[selectValue],
                  name: item[selectName1],
                  item,
                })
              }
              className="px-3 py-2 flex items-center justify-between gap-2 cursor-pointer text-sm
                text-slate-700 dark:text-slate-200 hover:bg-slate-50 dark:hover:bg-slate-700/80
                border-b border-slate-50 dark:border-slate-700 last:border-b-0"
            >
              <span className="font-medium truncate">{item[selectName1]}</span>
              <span className="text-slate-500 dark:text-slate-400 text-xs shrink-0">
                {selectName2 && item[selectName2]
                  ? item[selectName2]
                  : noMgs || ""}
                {extraMsg || ""}
              </span>
            </li>
          ))}
        </ul>
      )}
      {errors && (
        <p className="text-xs text-red-500 dark:text-red-400 mt-0.5">
          {errormessage ? errormessage : `${label} is mandatory`}
        </p>
      )}
    </div>
  );
};

export default InputDropSearch;
